import GATSBY_COMPILED_MDX from "/home/develop/pxplanding/data/industries/transportation/passport.mdx";
import React from "react";
import classnames from "classnames";
import * as styles from "./touchpoint.module.css";
import {Container, Content} from "../components/container/container";
import MainLayout from "../components/main-layout";
import {Link, navigate} from "gatsby";
import SEO from "../components/seo";
import {makeAbsoluteUrl} from "../utility";
import {SvgInline} from "../components/SVGInline";
import {getSrc} from "gatsby-plugin-image";
const mainStyles = {
  customer: styles.customer,
  employee: styles.employee
};
function TouchpointIcon(_ref) {
  let {name, logo, industryPath, selected} = _ref;
  return React.createElement(Link, {
    to: industryPath + "/touchpoint/" + name + "/"
  }, React.createElement("div", {
    className: classnames(styles.touchpointIcon, selected ? styles.touchpointIconSelected : "")
  }, React.createElement(SvgInline, {
    className: styles.logo,
    url: logo
  }), React.createElement("div", {
    className: classnames(styles.name, "subtitle-font")
  }, name)));
}
function TouchpointBar(_ref2) {
  let {touchpoints, selected, industryPath} = _ref2;
  const industry = React.useMemo(() => {
    const pathes = industryPath.split("/");
    return pathes[pathes.length - 1];
  }, [industryPath]);
  return React.createElement("div", {
    className: styles.touchpointBarContainer
  }, React.createElement("span", {
    className: styles.touchpointBarTitle
  }, industry), React.createElement("div", {
    className: styles.touchpointBar
  }, touchpoints.map((x, i) => React.createElement(TouchpointIcon, Object.assign({
    industryPath: industryPath
  }, x, {
    selected: x.name === selected,
    key: i
  })))));
}
function TouchpointTitle(_ref3) {
  let {logo, name} = _ref3;
  return React.createElement("div", {
    className: styles.touchpointTitle
  }, React.createElement(SvgInline, {
    className: styles.touchpointLogo,
    url: logo
  }), React.createElement("div", {
    className: styles.title
  }, React.createElement("div", {
    className: classnames("super-header-font", styles.titleName)
  }, name), React.createElement("div", {
    className: classnames("subtitle-font", styles.titleSubtitle)
  }, "Possibilities of vote collecting channels")));
}
function TouchpointTemplate(_ref4) {
  let {pageContext, children} = _ref4;
  React.useEffect(() => {
    window.scrollTo(0, 0);
    if (window.XPress) XPress.render();
  }, []);
  return React.createElement(MainLayout, {
    containerClassName: styles.mainContainer,
    mode: pageContext.type,
    HasFooter: true
  }, React.createElement("div", {
    style: {
      flex: 1,
      height: "100%"
    },
    className: mainStyles[pageContext.type]
  }, React.createElement(TouchpointBar, {
    touchpoints: pageContext.touchpoints,
    industryPath: pageContext.industryPath,
    selected: pageContext.name
  }), React.createElement(Container, {
    showBack: true,
    goBack: () => navigate(pageContext.industryPath),
    title: React.createElement(TouchpointTitle, {
      logo: pageContext.logo,
      name: pageContext.name
    }),
    className: styles.container,
    scrollable: true
  }, React.createElement(Content, null, children))));
}
export default function GatsbyMDXWrapper(props) {
  return React.createElement(TouchpointTemplate, props, React.createElement(GATSBY_COMPILED_MDX, props));
}
export const Head = _ref5 => {
  var _pageContext$frontmat;
  let {pageContext} = _ref5;
  const imageSrc = getSrc(pageContext.image);
  return React.createElement(SEO, {
    title: "Collect Feedback in " + pageContext.industry + " " + pageContext.name + " Touchpoint",
    description: pageContext.frontmatter.description,
    image: imageSrc ? makeAbsoluteUrl(imageSrc, false) : undefined,
    meta: [{
      name: "keywords",
      content: (_pageContext$frontmat = pageContext.frontmatter.keywords) === null || _pageContext$frontmat === void 0 ? void 0 : _pageContext$frontmat.join(",")
    }]
  });
};
